/** @license React v16.2.1
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var h = require("object-assign"),
    n = require("react"),
    aa = require("fbjs/lib/emptyFunction"),
    t = require("fbjs/lib/emptyObject"),
    ba = require("fbjs/lib/hyphenateStyleName"),
    ca = require("fbjs/lib/memoizeStringOnly");

function w(a) {
  for (var b = arguments.length - 1, g = "Minified React error #" + a + "; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d" + a, c = 0; c < b; c++) {
    g += "\x26args[]\x3d" + encodeURIComponent(arguments[c + 1]);
  }

  b = Error(g + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");
  b.name = "Invariant Violation";
  b.framesToPop = 1;
  throw b;
}

var x = {
  children: !0,
  dangerouslySetInnerHTML: !0,
  defaultValue: !0,
  defaultChecked: !0,
  innerHTML: !0,
  suppressContentEditableWarning: !0,
  suppressHydrationWarning: !0,
  style: !0
};

function z(a, b) {
  return (a & b) === b;
}

var B = {
  MUST_USE_PROPERTY: 1,
  HAS_BOOLEAN_VALUE: 4,
  HAS_NUMERIC_VALUE: 8,
  HAS_POSITIVE_NUMERIC_VALUE: 24,
  HAS_OVERLOADED_BOOLEAN_VALUE: 32,
  HAS_STRING_BOOLEAN_VALUE: 64,
  injectDOMPropertyConfig: function injectDOMPropertyConfig(a) {
    var b = B,
        g = a.Properties || {},
        c = a.DOMAttributeNamespaces || {},
        k = a.DOMAttributeNames || {};
    a = a.DOMMutationMethods || {};

    for (var f in g) {
      C.hasOwnProperty(f) ? w("48", f) : void 0;
      var e = f.toLowerCase(),
          d = g[f];
      e = {
        attributeName: e,
        attributeNamespace: null,
        propertyName: f,
        mutationMethod: null,
        mustUseProperty: z(d, b.MUST_USE_PROPERTY),
        hasBooleanValue: z(d, b.HAS_BOOLEAN_VALUE),
        hasNumericValue: z(d, b.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: z(d, b.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: z(d, b.HAS_OVERLOADED_BOOLEAN_VALUE),
        hasStringBooleanValue: z(d, b.HAS_STRING_BOOLEAN_VALUE)
      };
      1 >= e.hasBooleanValue + e.hasNumericValue + e.hasOverloadedBooleanValue ? void 0 : w("50", f);
      k.hasOwnProperty(f) && (e.attributeName = k[f]);
      c.hasOwnProperty(f) && (e.attributeNamespace = c[f]);
      a.hasOwnProperty(f) && (e.mutationMethod = a[f]);
      C[f] = e;
    }
  }
},
    C = {};

function da(a, b) {
  if (x.hasOwnProperty(a) || 2 < a.length && ("o" === a[0] || "O" === a[0]) && ("n" === a[1] || "N" === a[1])) return !1;
  if (null === b) return !0;

  switch (_typeof(b)) {
    case "boolean":
      return D(a);

    case "undefined":
    case "number":
    case "string":
    case "object":
      return !0;

    default:
      return !1;
  }
}

function E(a) {
  return C.hasOwnProperty(a) ? C[a] : null;
}

function D(a) {
  if (x.hasOwnProperty(a)) return !0;
  var b = E(a);
  if (b) return b.hasBooleanValue || b.hasStringBooleanValue || b.hasOverloadedBooleanValue;
  a = a.toLowerCase().slice(0, 5);
  return "data-" === a || "aria-" === a;
}

var F = B,
    G = F.MUST_USE_PROPERTY,
    H = F.HAS_BOOLEAN_VALUE,
    I = F.HAS_NUMERIC_VALUE,
    J = F.HAS_POSITIVE_NUMERIC_VALUE,
    K = F.HAS_OVERLOADED_BOOLEAN_VALUE,
    L = F.HAS_STRING_BOOLEAN_VALUE,
    ea = {
  Properties: {
    allowFullScreen: H,
    async: H,
    autoFocus: H,
    autoPlay: H,
    capture: K,
    checked: G | H,
    cols: J,
    contentEditable: L,
    controls: H,
    "default": H,
    defer: H,
    disabled: H,
    download: K,
    draggable: L,
    formNoValidate: H,
    hidden: H,
    loop: H,
    multiple: G | H,
    muted: G | H,
    noValidate: H,
    open: H,
    playsInline: H,
    readOnly: H,
    required: H,
    reversed: H,
    rows: J,
    rowSpan: I,
    scoped: H,
    seamless: H,
    selected: G | H,
    size: J,
    start: I,
    span: J,
    spellCheck: L,
    style: 0,
    tabIndex: 0,
    itemScope: H,
    acceptCharset: 0,
    className: 0,
    htmlFor: 0,
    httpEquiv: 0,
    value: L
  },
  DOMAttributeNames: {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
  },
  DOMMutationMethods: {
    value: function value(a, b) {
      if (null == b) return a.removeAttribute("value");
      "number" !== a.type || !1 === a.hasAttribute("value") ? a.setAttribute("value", "" + b) : a.validity && !a.validity.badInput && a.ownerDocument.activeElement !== a && a.setAttribute("value", "" + b);
    }
  }
},
    M = F.HAS_STRING_BOOLEAN_VALUE,
    N = {
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace"
},
    O = {
  Properties: {
    autoReverse: M,
    externalResourcesRequired: M,
    preserveAlpha: M
  },
  DOMAttributeNames: {
    autoReverse: "autoReverse",
    externalResourcesRequired: "externalResourcesRequired",
    preserveAlpha: "preserveAlpha"
  },
  DOMAttributeNamespaces: {
    xlinkActuate: N.xlink,
    xlinkArcrole: N.xlink,
    xlinkHref: N.xlink,
    xlinkRole: N.xlink,
    xlinkShow: N.xlink,
    xlinkTitle: N.xlink,
    xlinkType: N.xlink,
    xmlBase: N.xml,
    xmlLang: N.xml,
    xmlSpace: N.xml
  }
},
    fa = /[\-\:]([a-z])/g;

function ha(a) {
  return a[1].toUpperCase();
}

"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function (a) {
  var b = a.replace(fa, ha);
  O.Properties[b] = 0;
  O.DOMAttributeNames[b] = a;
});
F.injectDOMPropertyConfig(ea);
F.injectDOMPropertyConfig(O);
var P = "function" === typeof Symbol && Symbol["for"] ? Symbol["for"]("react.fragment") : 60107,
    ia = /["'&<>]/;

function Q(a) {
  if ("boolean" === typeof a || "number" === typeof a) return "" + a;
  a = "" + a;
  var b = ia.exec(a);

  if (b) {
    var g = "",
        c,
        k = 0;

    for (c = b.index; c < a.length; c++) {
      switch (a.charCodeAt(c)) {
        case 34:
          b = "\x26quot;";
          break;

        case 38:
          b = "\x26amp;";
          break;

        case 39:
          b = "\x26#x27;";
          break;

        case 60:
          b = "\x26lt;";
          break;

        case 62:
          b = "\x26gt;";
          break;

        default:
          continue;
      }

      k !== c && (g += a.substring(k, c));
      k = c + 1;
      g += b;
    }

    a = k !== c ? g + a.substring(k, c) : g;
  }

  return a;
}

var ja = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    R = {},
    S = {};

function T(a) {
  if (S.hasOwnProperty(a)) return !0;
  if (R.hasOwnProperty(a)) return !1;
  if (ja.test(a)) return S[a] = !0;
  R[a] = !0;
  return !1;
}

function ka(a, b) {
  var g = E(a);

  if (g) {
    if (null == b || g.hasBooleanValue && !b || g.hasNumericValue && isNaN(b) || g.hasPositiveNumericValue && 1 > b || g.hasOverloadedBooleanValue && !1 === b) return "";
    var c = g.attributeName;
    if (g.hasBooleanValue || g.hasOverloadedBooleanValue && !0 === b) return c + '\x3d""';
    if ("boolean" !== typeof b || D(a)) return c + "\x3d" + ('"' + Q(b) + '"');
  } else if (da(a, b) && T(a)) return null == b ? "" : a + "\x3d" + ('"' + Q(b) + '"');

  return null;
}

var U = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg"
};

function V(a) {
  switch (a) {
    case "svg":
      return "http://www.w3.org/2000/svg";

    case "math":
      return "http://www.w3.org/1998/Math/MathML";

    default:
      return "http://www.w3.org/1999/xhtml";
  }
}

var W = {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
},
    la = h({
  menuitem: !0
}, W),
    X = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
},
    ma = ["Webkit", "ms", "Moz", "O"];
Object.keys(X).forEach(function (a) {
  ma.forEach(function (b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);
    X[b] = X[a];
  });
});
var Y = n.Children.toArray,
    na = aa.thatReturns(""),
    oa = {
  listing: !0,
  pre: !0,
  textarea: !0
};

function pa(a) {
  return "string" === typeof a ? a : "function" === typeof a ? a.displayName || a.name : null;
}

var qa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,
    ra = {},
    sa = ca(function (a) {
  return ba(a);
});

function ta(a) {
  var b = "";
  n.Children.forEach(a, function (a) {
    null == a || "string" !== typeof a && "number" !== typeof a || (b += a);
  });
  return b;
}

function ua(a, b) {
  if (a = a.contextTypes) {
    var g = {},
        c;

    for (c in a) {
      g[c] = b[c];
    }

    b = g;
  } else b = t;

  return b;
}

var va = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null,
  suppressHydrationWarning: null
};

function wa(a, b) {
  void 0 === a && w("152", pa(b) || "Component");
}

function xa(a, b) {
  for (; n.isValidElement(a);) {
    var g = a,
        c = g.type;
    if ("function" !== typeof c) break;
    a = ua(c, b);
    var k = [],
        f = !1,
        e = {
      isMounted: function isMounted() {
        return !1;
      },
      enqueueForceUpdate: function enqueueForceUpdate() {
        if (null === k) return null;
      },
      enqueueReplaceState: function enqueueReplaceState(a, b) {
        f = !0;
        k = [b];
      },
      enqueueSetState: function enqueueSetState(a, b) {
        if (null === k) return null;
        k.push(b);
      }
    };
    if (c.prototype && c.prototype.isReactComponent) var d = new c(g.props, a, e);else if (d = c(g.props, a, e), null == d || null == d.render) {
      a = d;
      wa(a, c);
      continue;
    }
    d.props = g.props;
    d.context = a;
    d.updater = e;
    e = d.state;
    void 0 === e && (d.state = e = null);
    if (d.componentWillMount) if (d.componentWillMount(), k.length) {
      e = k;
      var p = f;
      k = null;
      f = !1;
      if (p && 1 === e.length) d.state = e[0];else {
        var q = p ? e[0] : d.state,
            l = !0;

        for (p = p ? 1 : 0; p < e.length; p++) {
          var m = e[p];
          if (m = "function" === typeof m ? m.call(d, q, g.props, a) : m) l ? (l = !1, q = h({}, q, m)) : h(q, m);
        }

        d.state = q;
      }
    } else k = null;
    a = d.render();
    wa(a, c);

    if ("function" === typeof d.getChildContext && (g = c.childContextTypes, "object" === _typeof(g))) {
      var A = d.getChildContext();

      for (var y in A) {
        y in g ? void 0 : w("108", pa(c) || "Unknown", y);
      }
    }

    A && (b = h({}, b, A));
  }

  return {
    child: a,
    context: b
  };
}

var ya = function () {
  function a(b, g) {
    if (!(this instanceof a)) throw new TypeError("Cannot call a class as a function");
    n.isValidElement(b) ? b.type !== P ? b = [b] : (b = b.props.children, b = n.isValidElement(b) ? [b] : Y(b)) : b = Y(b);
    this.stack = [{
      domNamespace: U.html,
      children: b,
      childIndex: 0,
      context: t,
      footer: ""
    }];
    this.exhausted = !1;
    this.currentSelectValue = null;
    this.previousWasTextNode = !1;
    this.makeStaticMarkup = g;
  }

  a.prototype.read = function (a) {
    if (this.exhausted) return null;

    for (var b = ""; b.length < a;) {
      if (0 === this.stack.length) {
        this.exhausted = !0;
        break;
      }

      var c = this.stack[this.stack.length - 1];

      if (c.childIndex >= c.children.length) {
        var k = c.footer;
        b += k;
        "" !== k && (this.previousWasTextNode = !1);
        this.stack.pop();
        "select" === c.tag && (this.currentSelectValue = null);
      } else k = c.children[c.childIndex++], b += this.render(k, c.context, c.domNamespace);
    }

    return b;
  };

  a.prototype.render = function (a, g, c) {
    if ("string" === typeof a || "number" === typeof a) {
      c = "" + a;
      if ("" === c) return "";
      if (this.makeStaticMarkup) return Q(c);
      if (this.previousWasTextNode) return "\x3c!-- --\x3e" + Q(c);
      this.previousWasTextNode = !0;
      return Q(c);
    }

    g = xa(a, g);
    a = g.child;
    g = g.context;
    if (null === a || !1 === a) return "";
    if (n.isValidElement(a)) return a.type === P ? (a = Y(a.props.children), this.stack.push({
      domNamespace: c,
      children: a,
      childIndex: 0,
      context: g,
      footer: ""
    }), "") : this.renderDOM(a, g, c);
    a = Y(a);
    this.stack.push({
      domNamespace: c,
      children: a,
      childIndex: 0,
      context: g,
      footer: ""
    });
    return "";
  };

  a.prototype.renderDOM = function (a, g, c) {
    var b = a.type.toLowerCase();
    c === U.html && V(b);
    ra.hasOwnProperty(b) || (qa.test(b) ? void 0 : w("65", b), ra[b] = !0);
    var f = a.props;
    if ("input" === b) f = h({
      type: void 0
    }, f, {
      defaultChecked: void 0,
      defaultValue: void 0,
      value: null != f.value ? f.value : f.defaultValue,
      checked: null != f.checked ? f.checked : f.defaultChecked
    });else if ("textarea" === b) {
      var e = f.value;

      if (null == e) {
        e = f.defaultValue;
        var d = f.children;
        null != d && (null != e ? w("92") : void 0, Array.isArray(d) && (1 >= d.length ? void 0 : w("93"), d = d[0]), e = "" + d);
        null == e && (e = "");
      }

      f = h({}, f, {
        value: void 0,
        children: "" + e
      });
    } else if ("select" === b) this.currentSelectValue = null != f.value ? f.value : f.defaultValue, f = h({}, f, {
      value: void 0
    });else if ("option" === b) {
      d = this.currentSelectValue;
      var p = ta(f.children);

      if (null != d) {
        var q = null != f.value ? f.value + "" : p;
        e = !1;
        if (Array.isArray(d)) for (var l = 0; l < d.length; l++) {
          if ("" + d[l] === q) {
            e = !0;
            break;
          }
        } else e = "" + d === q;
        f = h({
          selected: void 0,
          children: void 0
        }, f, {
          selected: e,
          children: p
        });
      }
    }
    if (e = f) la[b] && (null != e.children || null != e.dangerouslySetInnerHTML ? w("137", b, na()) : void 0), null != e.dangerouslySetInnerHTML && (null != e.children ? w("60") : void 0, "object" === _typeof(e.dangerouslySetInnerHTML) && "__html" in e.dangerouslySetInnerHTML ? void 0 : w("61")), null != e.style && "object" !== _typeof(e.style) ? w("62", na()) : void 0;
    e = f;
    d = this.makeStaticMarkup;
    p = 1 === this.stack.length;
    q = "\x3c" + a.type;

    for (r in e) {
      if (e.hasOwnProperty(r)) {
        var m = e[r];

        if (null != m) {
          if ("style" === r) {
            l = void 0;
            var A = "",
                y = "";

            for (l in m) {
              if (m.hasOwnProperty(l)) {
                var u = 0 === l.indexOf("--"),
                    v = m[l];
                null != v && (A += y + sa(l) + ":", y = l, u = null == v || "boolean" === typeof v || "" === v ? "" : u || "number" !== typeof v || 0 === v || X.hasOwnProperty(y) && X[y] ? ("" + v).trim() : v + "px", A += u, y = ";");
              }
            }

            m = A || null;
          }

          l = null;

          b: if (u = b, v = e, -1 === u.indexOf("-")) u = "string" === typeof v.is;else switch (u) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              u = !1;
              break b;

            default:
              u = !0;
          }

          u ? va.hasOwnProperty(r) || (l = r, l = T(l) && null != m ? l + "\x3d" + ('"' + Q(m) + '"') : "") : l = ka(r, m);
          l && (q += " " + l);
        }
      }
    }

    d || p && (q += ' data-reactroot\x3d""');
    var r = q;
    e = "";
    W.hasOwnProperty(b) ? r += "/\x3e" : (r += "\x3e", e = "\x3c/" + a.type + "\x3e");

    a: {
      d = f.dangerouslySetInnerHTML;

      if (null != d) {
        if (null != d.__html) {
          d = d.__html;
          break a;
        }
      } else if (d = f.children, "string" === typeof d || "number" === typeof d) {
        d = Q(d);
        break a;
      }

      d = null;
    }

    null != d ? (f = [], oa[b] && "\n" === d.charAt(0) && (r += "\n"), r += d) : f = Y(f.children);
    a = a.type;
    c = null == c || "http://www.w3.org/1999/xhtml" === c ? V(a) : "http://www.w3.org/2000/svg" === c && "foreignObject" === a ? "http://www.w3.org/1999/xhtml" : c;
    this.stack.push({
      domNamespace: c,
      tag: b,
      children: f,
      childIndex: 0,
      context: g,
      footer: e
    });
    this.previousWasTextNode = !1;
    return r;
  };

  return a;
}(),
    za = {
  renderToString: function renderToString(a) {
    return new ya(a, !1).read(Infinity);
  },
  renderToStaticMarkup: function renderToStaticMarkup(a) {
    return new ya(a, !0).read(Infinity);
  },
  renderToNodeStream: function renderToNodeStream() {
    w("207");
  },
  renderToStaticNodeStream: function renderToStaticNodeStream() {
    w("208");
  },
  version: "16.2.1"
},
    Aa = Object.freeze({
  default: za
}),
    Z = Aa && za || Aa;

module.exports = Z["default"] ? Z["default"] : Z;